/**
 * API Client
 * Handles communication with the HellaBots API
 */

import type { LeadData } from '../types'

const API_BASE_URL = (import.meta as any).env?.VITE_API_URL || 'https://qihmh0pa24.execute-api.us-west-2.amazonaws.com'

export interface SubmitLeadResponse {
  success: boolean
  leadId: string
  message: string
}

export interface MessageRequest {
  clientId: string
  userQuestion: string
  leadContext?: {
    name?: string
    type?: 'buyer' | 'seller' | 'question'
  } | undefined
}

export interface MessageResponse {
  success: boolean
  response: string
  fallback: boolean
}

/**
 * Submit lead to API
 */
export async function submitLead(leadData: LeadData): Promise<SubmitLeadResponse> {
  const response = await fetch(`${API_BASE_URL}/leads`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(leadData),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }))
    throw new Error(error.error || `HTTP ${response.status}`)
  }

  return response.json()
}

/**
 * Get AI response to user message
 */
export async function getMessageResponse(request: MessageRequest): Promise<MessageResponse> {
  const response = await fetch(`${API_BASE_URL}/messages`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }))
    throw new Error(error.error || `HTTP ${response.status}`)
  }

  return response.json()
}
